import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { SAYILI, okumaDenetimi } from './kesikOkuma';

// YER GOREVI / EGITIM SEHIRLERI — okuma ve ekleme TEK YERDE.
//
// Hem FTL yer gorevi formu hem egitim kaydi formu ayni listeyi kullanir ve
// ikisinden de "oracikta" sehir eklenebilir (Serkan: *"her kutuda OTHER
// secenegi olsun, ona tiklayinca ADD diye sorsun"* · *"ekler oracikta"*).
// Ekleme mantigi iki ayri dosyaya yazilsaydi er ya da gec ayrisirdi (Ilke 3) —
// bu yuzden DB islemi burada, bilesenler yalnizca cagirir.
//
// 🔴 21 Eki 2026 (kod taraması W4): okuma hatayı yutuyordu — düşünce şehir listesi BOŞ görünür, kullanıcı "yok" sanıp
//    aynı şehri yeniden eklemeye kalkardı. Artık `okumaHatasi` (OkumaHatasi kutusunun satırları) döner; kullanan ekran
//    onu kendi okuma kutusuna katar (yarım veriyle form açılmaz).
export function useDutyLocations(customerId) {
  const [locations, setLocations] = useState([]);
  const [okumaHatasi, setOkumaHatasi] = useState(null);

  const load = useCallback(async () => {
    if (!customerId) return;
    const { dustu, oku } = okumaDenetimi();
    const data = oku('DUTY LOCATIONS (duty_locations)', await supabase.from('duty_locations')
      .select('*', SAYILI).eq('customer_id', customerId).eq('active', true).order('city'));
    setOkumaHatasi(dustu.length ? dustu : null);
    setLocations(dustu.length ? [] : (data || []));
  }, [customerId]);

  useEffect(() => { load(); }, [load]);

  /** Yeni sehir. Dilimi olmayan sehir EKLENMEZ — semada `iana_tz NOT NULL`,
   *  burada da erken duruyoruz: etiketi olan ama hesabi olmayan kayit
   *  dogmasin (Ilke 1). Hata YUTULMAZ, cagirana firlatilir (Ilke 2). */
  const addLocation = useCallback(async (row) => {
    if (!row?.iana_tz) throw new Error('A city cannot be added without its timezone.');
    const { data, error } = await supabase.from('duty_locations')
      .insert([{ ...row, customer_id: customerId }]).select().single();
    if (error) throw new Error(error.message);
    setLocations(prev => [...prev, data]
      .sort((a, b) => String(a.city).localeCompare(String(b.city))));
    return data;
  }, [customerId]);

  return { locations, okumaHatasi, addLocation, reloadLocations: load };
}
